export default {
  server: {
    appName: 'Directory App',
    stage: 'production',
    port: '3300',
    host: 'localhost',
  },
  config: {
    brandName: 'Sanamia',
    defaultLanguage: 'de',
    defaultLanguageFull: 'de-DE',
    isDirectoryEnabled: '1',
    isBookingEnabled: '1',
    isLoginEnabled: '1',
  },
  images: {
    logoWhite: '',
    logoBlue: '',
    favicon: '',
  },
  links: {
    faqURL: '',
    termsURL: '',
    privacyURL: '',
    bookingTermsURL: '',
  },
  api: {
    commonService: 'https://commonapi.itherapeut.ch',
    directoryEngine: 'https://directoryapi.itherapeut.ch',
    bookingEngine: 'https://bookingapi.itherapeut.ch',
    providerApps: 'https://account.itherapeut.ch',
    consumerApps: 'https://sanamia.ch',
    bucketBaseUrl: 'https://sos-ch-dk-2.exo.io/itherapeut-web-public/booking_external',
  },
  keys: {
    hCaptchaKey: '9cda7cc6-c7ac-48e6-8f02-2666538864ae',
  },
};
